import * as React from 'react';

import type {ContentType} from './audit-log-wrapper';
import {BulkEditsTable} from './bulk-edits-table';
import {ListActionsTab} from './list-actions-tab';
import {UserLoginsTab} from './user-logins-tab';

import styles from './audit-log.module.css';

type Props = {
    contentType: ContentType;
    onParamChange: (params: any) => void;
    filterByUserId: string | null | undefined;
};

export function AuditLogContent(props: Props) {
    return (
        <div className={styles['content-container']}>
            {props.contentType === 'bulk-edits' && <BulkEditsTable />}
            {props.contentType === 'logins' && (
                <UserLoginsTab
                    onParamChange={props.onParamChange}
                    filterByUserId={props.filterByUserId}
                />
            )}
            {props.contentType === 'list-actions' && (
                <ListActionsTab
                    onParamChange={props.onParamChange}
                    filterByUserId={props.filterByUserId}
                />
            )}
        </div>
    );
}
